import builder from '../builder';
import ResizeExpandSides from '../../streamline-icons/light/resize-expand-sides.svg';

export default builder('IconResizeExpandSidesLight', ResizeExpandSides);
